export const READY_TO_BEGIN = "ready to begin";
export const IN_PROGRESS = "in progress";
export const IN_SHOPPING_CART = "in shopping cart";
